import { BaseElement, defineElement, html, TemplateElement } from '@webtides/element-js';

class FlyoutBackdrop extends BaseElement {
    constructor() {
        super();
    }

    connected() {
        if (this.applyDefaultStyling) {
            this.classList.add(this.closedClass, 'inset-0', 'fixed', 'is-open');
        }
    }

    properties() {
        return {
            open: false,
            closedClass: 'hidden',
            openedClass: 'block',
            applyDefaultStyling: true,
            top: 0,
            fitConatinerHeight: false,
        };
    }

    watch() {
        return {
            open: () => {
                if (this.fitContainerHeight) {
                    this.style.height = this.parentNode.offsetHeight + 'px';
                }

                if (!!this.overlayElement) {
                    const element = document.querySelector(this.overlayElement);
                    if (element) {
                        this.classList.remove('fixed');
                        this.classList.add('absolute');

                        this.style.height = element.offsetHeight + 'px';
                    }

                    this.style.top = this.top + 'px';
                }

                this.classList.toggle(this.closedClass, !this.open);
                this.classList.toggle(this.openedClass, this.open);
            },
        };
    }
}

defineElement('flyout-backdrop', FlyoutBackdrop);
